export default {

    //uiBaseUrl: 'https://www.meydiageo.com',
    //apiBaseUrl: 'https://api.meydiageo.com',
    //dashboardBaseUrl: 'https://dashboard.meydiageo.com',

    uiBaseUrl: 'http://ui.mey.limeorlemon.com',
    apiBaseUrl: 'http://api.mey.limeorlemon.com',
    dashboardBaseUrl: 'http://dashboard.mey.limeorlemon.com',

    //uiBaseUrl: 'https://preproduidiageoturkiye.limeorlemon.com',
    //apiBaseUrl: 'https://preprodapidiageoturkiye.limeorlemon.com',
    //dashboardBaseUrl: 'https://preproddashboarddiageoturkiye.limeorlemon.com',
}